
import React, { useContext } from "react";
import { FaGavel, FaBalanceScale, FaBookOpen, FaLandmark } from 'react-icons/fa';
import { useNavigate } from "react-router-dom";
import { AuthContext } from "../../context/AuthContext";
import './ConsultancyGlobal.css';
import BannerImage from './consultancy_hero.png';

function SafetyLegislation() {
  const navigate = useNavigate();
  const { isAuthenticated } = useContext(AuthContext);

  const handleBooking = () => {
    if (isAuthenticated) {
      navigate('/booking/safety-legislation-consultancy');
    } else {
      navigate('/login', { state: { from: '/booking/safety-legislation-consultancy' } });
    }
  };

  return (
    <div className="consultancy-page">
      <div className="consultancy-max-width">

        {/* --- HERO --- */}
        <div className="consultancy-hero" style={{ backgroundImage: `url(${BannerImage})` }}>
          <span className="hero-tag">Legal Compliance</span>
          <h1 className="hero-title">Safety Legislation</h1>
          <p className="hero-subtitle">
            Navigating the Indian legal framework. Factories Act, BOCW, and Environmental Protection
            laws decoded for your business.
          </p>
          <button onClick={handleBooking} className="btn-hero">
            Get Consulted <span style={{ fontSize: '1.2em' }}>→</span>
          </button>
        </div>

        {/* --- CONTENT --- */}
        <div className="detail-content">

          <div className="content-article">
            <div className="article-section">
              <h2 className="article-heading">The Regulatory Landscape</h2>
              <p className="article-text">
                Safety compliance is comprehensive in India. It requires deep knowledge of both central
                and state-specific rules. Ignorance of the law is not an excuse. We help you audit your
                status and close compliance gaps before they become legal liabilities.
              </p>
            </div>

            <div className="article-section">
              <h2 className="article-heading">Key Acts & Rules</h2>
              <div style={{ display: 'grid', gridTemplateColumns: '1fr 1fr', gap: '20px', marginTop: '20px' }}>
                <div style={{ background: '#111', padding: '15px', borderRadius: '8px', border: '1px solid #222' }}>
                  <strong style={{ color: '#fff' }}>The Factories Act, 1948</strong>
                  <p style={{ color: '#888', fontSize: '0.9rem', marginTop: '5px' }}>
                    Health, safety, welfare, working hours, and leave.
                  </p>
                </div>
                <div style={{ background: '#111', padding: '15px', borderRadius: '8px', border: '1px solid #222' }}>
                  <strong style={{ color: '#fff' }}>BOCW Act, 1996</strong>
                  <p style={{ color: '#888', fontSize: '0.9rem', marginTop: '5px' }}>
                    Specifically for building and other construction workers.
                  </p>
                </div>
                <div style={{ background: '#111', padding: '15px', borderRadius: '8px', border: '1px solid #222' }}>
                  <strong style={{ color: '#fff' }}>Environment Protection Act</strong>
                  <p style={{ color: '#888', fontSize: '0.9rem', marginTop: '5px' }}>
                    Pollution control, waste disposal, and clearances.
                  </p>
                </div>
                <div style={{ background: '#111', padding: '15px', borderRadius: '8px', border: '1px solid #222' }}>
                  <strong style={{ color: '#fff' }}>Petroleum & Explosives Acts</strong>
                  <p style={{ color: '#888', fontSize: '0.9rem', marginTop: '5px' }}>
                    Storage, transport, and handling of hazardous substances.
                  </p>
                </div>
              </div>
            </div>

            <div className="article-section">
              <h2 className="article-heading">Our Consultation Services</h2>
              <p className="article-text">
                We provide Legal Registers, Liaison with authorities (Factory Inspectorate, Pollution Control Board),
                and Third-Party Legal Compliance Audits to ensure you are always audit-ready.
              </p>
            </div>
          </div>

          {/* --- SIDEBAR --- */}
          <div className="content-sidebar">
            <div className="sidebar-widget">
              <h4 className="widget-title">Compliance Areas</h4>
              <ul className="key-list">
                <li><FaGavel className="check-icon" /> Factory Licensing</li>
                <li><FaBookOpen className="check-icon" /> Statutory Registers</li>
                <li><FaLandmark className="check-icon" /> Returns Filing</li>
                <li><FaBalanceScale className="check-icon" /> Audit Representation</li>
              </ul>
            </div>

            <div className="sidebar-widget" style={{ background: 'linear-gradient(135deg, #111 0%, #222 100%)', border: '1px solid #333' }}>
              <h4 className="widget-title">Legal Shield</h4>
              <p style={{ color: '#ccc', marginBottom: '20px', fontSize: '0.9rem' }}>
                Protect your business today.
              </p>

              <button
                onClick={handleBooking}
                className="btn-primary"
                style={{ width: '100%', justifyContent: 'center' }}
              >
                Book Now
              </button>
            </div>
          </div>

        </div>
      </div>
    </div>
  );
}

export default SafetyLegislation;
